import * as React from "react"
import { Row, Col, Button, Alert, FormGroup, ButtonGroup } from "reactstrap"
import { FormattedMessage, intlShape } from "react-intl"
import {
  ValidationForm,
  TextInput,
  TextInputGroup
} from "react-bootstrap4-form-validation"
import { connect } from "react-redux"
import SagaAuthRedux from "../../redux/sagaAuth/sagaAuthRedux"
import {
  IRegister,
  IExternalSignin,
  ICustomerReq
} from "../../redux/sagaAuth/ISagaAuth"
import validator from "validator"
// import AvatarUploader from "../utility/avatarUpload/avatarUploader"
import * as R from "ramda"
import GoogleLogin from "react-google-login"
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props"
import AppConfig from "../../configs/AppConfig"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  CUSTOMER_TYPE_PERSONAL,
  CUSTOMER_TYPE_CORPORATION,
  WEB
} from "../../constants/customer"

interface IPropType {
  requestRegister: (data: IRegister) => void
  requestExternalLogin: (data: IExternalSignin) => void
  requestCustomerRegister: (customerReq: ICustomerReq, culture: string) => void
  registerFetching: boolean
  registerResponse: boolean
  registerError: string
}

interface IStateType {
  data: IRegister
  pictures: any
  culture: string
  passwordType: string
  customerType: number
  customerReq: ICustomerReq
}

class Register extends React.Component<IPropType, IStateType> {
  /* tslint:disable */
  private static contextTypes = {
    intl: intlShape
  }

  constructor(props, context) {
    super(props)
    this.state = {
      data: null,
      pictures: [],
      passwordType: "password",
      customerType: CUSTOMER_TYPE_PERSONAL,
      culture: '',
      customerReq: {
        email: "",
        ssn: "",
        password: null,
        firstName: "",
        lastName: "",
        address: "",
        mobilePhone: "",
        companyPhoneNumber: "",
        profilePicture: "",
        base64Picture: "",
        userName: "",
        customerType: CUSTOMER_TYPE_PERSONAL,
        customerChannel: WEB,
        lineID: "",
        companyName: "",
        address1: "",
        taxID: "",
        address2: ""
      }
    }
    this.context = context
  }

  public onSeePassword() {
    this.setState({
      passwordType: this.state.passwordType === "input" ? "password" : "input"
    })
  }

  public onSubmit(e) {
    e.preventDefault()
    // invoke singin api
    const customer = this.state.customerReq
    customer.customerType = this.state.customerType
    this.props.requestCustomerRegister(this.state.customerReq, this.state.culture )
  }

  public onDrop(pictureFiles) {
    this.setState({
      pictures: this.state.pictures.concat(pictureFiles)
    })
  }

  public onRegisterChanged(value) {
    if (value == null) {
      return
    }
    let customerReq = this.state.customerReq
    customerReq = R.merge(customerReq, value)
    this.setState({ customerReq })
  }

  public responseFacebook(response) {
    console.log("response from facebook register", response)
    if (response.accessToken && response.email && response.id) {
      // invoke external signin api
      const data: IExternalSignin = {
        accessToken: response.accessToken,
        email: response.email,
        familyName: response.name,
        givenName: response.name,
        provider: "facebook",
        mobilePhone: "",
        imageUrl: "",
        providerId: response.userID
      }
      this.props.requestExternalLogin(data)
    } else {
      alert("Social logins require cookies enabled. Please exit incognito mode")
    }
  }

  public responseGoogle(response) {
    console.log("*** response from google login", response)
    if (response.accessToken && response.googleId && response.profileObj) {
      // invoke external signin api
      const data: IExternalSignin = {
        accessToken: response.accessToken,
        email: response.profileObj.email,
        familyName: response.profileObj.familyName,
        givenName: response.profileObj.givenName,
        provider: "google",
        mobilePhone: "",
        imageUrl: response.profileObj.imageUrl,
        providerId: response.googleId
      }
      this.props.requestExternalLogin(data)
    } else {
      alert("Social logins require cookies enabled. Please exit incognito mode")
    }
  }

  public renderIcon() {
    return this.state.passwordType === "password" ? (
      <FontAwesomeIcon icon={["fas", "eye"]} />
    ) : (
      <FontAwesomeIcon icon={["fas", "eye-slash"]} />
    )
  }
  public check(b) {
    this.setState({
      customerType: b
    })
  }

  public render() {
    const { customerType, customerReq } = this.state
    return (
      <ValidationForm onSubmit={e => this.onSubmit(e)}>
        <Row className="mb-3"></Row>
        <Row form className="mb-3">
          <Col md={12} sm={12}>
            <ButtonGroup>
              <Button
                color={
                  customerType === CUSTOMER_TYPE_PERSONAL
                    ? "danger"
                    : "secondary"
                }
                togglable={true}
                onClick={b => {
                  this.check(CUSTOMER_TYPE_PERSONAL)
                }}
              >
                <FormattedMessage id="personal" />
              </Button>
              <Button
                color={
                  customerType === CUSTOMER_TYPE_CORPORATION
                    ? "danger"
                    : "secondary"
                }
                togglable={true}
                onClick={b => {
                  this.check(CUSTOMER_TYPE_CORPORATION)
                }}
              >
                <FormattedMessage id="corporation" />
              </Button>
            </ButtonGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={12} sm={12}>
            <FormGroup>
              <TextInput
                name="register-email"
                id="register-email"
                type="email"
                validator={validator.isEmail}
                placeholder={this.context.intl.formatMessage({ id: "Email" })}
                onChange={e =>
                  this.onRegisterChanged({ email: e.target.value })
                }
                errorMessage={{
                  required: (
                    <FormattedMessage id="Signin.Validation.Email.Required" />
                  ),
                  validator: (
                    <FormattedMessage id="Signin.Validation.Email.Invalid" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInputGroup
                name="register-password"
                id="register-password"
                type={this.state.passwordType}
                placeholder={this.context.intl.formatMessage({
                  id: "Password"
                })}
                onChange={e =>
                  this.onRegisterChanged({ password: e.target.value })
                }
                errorMessage={{
                  required: (
                    <FormattedMessage id="Signin.Validation.Password.Required" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInputGroup
                name="register-confirmpassword"
                id="register-confirmpassword"
                type={this.state.passwordType}
                placeholder={this.context.intl.formatMessage({
                  id: "ConfirmPassword"
                })}
                validator={value => {
                  if (
                    !value ||
                    !this.state.customerReq ||
                    !this.state.customerReq.password
                  ) {
                    return false
                  } else {
                    return value === this.state.customerReq.password
                  }
                }}
                errorMessage={{
                  required: (
                    <FormattedMessage id="register.Validation.ConfirmPassword.Required" />
                  ),
                  validator: (
                    <FormattedMessage id="register.Validation.ConfirmPassword.Validator" />
                  )
                }}
                required
                append={
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => this.onSeePassword()}
                  >
                    {this.renderIcon()}
                  </button>
                }
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={12} sm={12}>
            <FormGroup>
              <TextInput
                name="register-ssn"
                id="register-ssn"
                placeholder={this.context.intl.formatMessage({
                  id: "Identification_Number"
                })}
                onChange={e => this.onRegisterChanged({ ssn: e.target.value })}
                errorMessage={{
                  required: (
                    <FormattedMessage id="register.Validation.Identification.Number" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInput
                name="register-firstname"
                id="register-firstname"
                placeholder={this.context.intl.formatMessage({
                  id: "FirstName"
                })}
                onChange={e =>
                  this.onRegisterChanged({ firstName: e.target.value })
                }
                errorMessage={{
                  required: (
                    <FormattedMessage id="register.Validation.FirstName.Required" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInput
                name="register-lastname"
                id="register-lastname"
                placeholder={this.context.intl.formatMessage({
                  id: "LastName"
                })}
                onChange={e =>
                  this.onRegisterChanged({ lastName: e.target.value })
                }
                errorMessage={{
                  required: (
                    <FormattedMessage id="register.Validation.LastName.Required" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
        </Row>
        <Row form>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInput
                name="register-phonenumber"
                id="register-phonenumber"
                pattern="[0-9]*"
                placeholder={this.context.intl.formatMessage({
                  id: "PhoneNumber"
                })}
                onChange={e =>
                  this.onRegisterChanged({ mobilePhone: e.target.value })
                }
                errorMessage={{
                  required: (
                    <FormattedMessage id="register.Validation.PhoneNumber.Required" />
                  )
                }}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6} sm={12}>
            <FormGroup>
              <TextInput
                name="register-lineid"
                id="register-lineid"
                placeholder={this.context.intl.formatMessage({
                  id: "LineId"
                })}
                onChange={e =>
                  this.onRegisterChanged({ lineID: e.target.value })
                }
              />
            </FormGroup>
          </Col>
        </Row>

        {customerType === CUSTOMER_TYPE_CORPORATION ? (
          <React.Fragment>
            <Row form>
              <Col md={0} sm={12}>
                <FormGroup>
                  <TextInput
                    name="register-companyname"
                    id="register-companyname"
                    placeholder={this.context.intl.formatMessage({
                      id: "companyname"
                    })}
                    onChange={e =>
                      this.onRegisterChanged({ companyName: e.target.value })
                    }
                    errorMessage={{
                      required: (
                        <FormattedMessage id="register.Validation.CompanyName.Required" />
                      )
                    }}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6} sm={12}>
                <FormGroup>
                  <TextInput
                    name="register-companyphone"
                    id="register-companyphone"
                    pattern="[0-9]*"
                    placeholder={this.context.intl.formatMessage({
                      id: "taxId"
                    })}
                    onChange={e =>
                      this.onRegisterChanged({
                        taxId: e.target.value
                      })
                    }
                    errorMessage={{
                      required: (
                        <FormattedMessage id="register.Validation.TaxId.Required" />
                      )
                    }}
                    required
                  />
                </FormGroup>
              </Col>
              <Col md={6} sm={12}>
                <FormGroup>
                  <TextInput
                    name="register-companyphone"
                    id="register-companyphone"
                    pattern="[0-9]*"
                    placeholder={this.context.intl.formatMessage({
                      id: "PhoneNumber"
                    })}
                    onChange={e =>
                      this.onRegisterChanged({
                        companyPhoneNumber: e.target.value
                      })
                    }
                    errorMessage={{
                      required: (
                        <FormattedMessage id="register.Validation.PhoneNumber.Required" />
                      )
                    }}
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={0} sm={12}>
                <FormGroup>
                  <TextInput
                    name="register-companyaddress"
                    id="register-companyaddress"
                    placeholder={this.context.intl.formatMessage({
                      id: "CompanyAddress"
                    })}
                    onChange={e =>
                      this.onRegisterChanged({ address1: e.target.value })
                    }
                    errorMessage={{
                      required: (
                        <FormattedMessage id="register.Validation.CompanyAddress.Required" />
                      )
                    }}
                    multiline
                    required
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={0} sm={12}>
                <FormGroup>
                  <TextInput
                    name="register-companyaddress"
                    id="register-companyaddress"
                    placeholder={this.context.intl.formatMessage({
                      id: "CompanyAddress"
                    })}
                    onChange={e =>
                      this.onRegisterChanged({
                        address2: e.target.value
                      })
                    }
                    multiline
                  />
                </FormGroup>
              </Col>
            </Row>
          </React.Fragment>
        ) : null}
        <Row className="mb-3">
          <Col md={6} sm={12}>
            <Button color="danger" disabled={this.props.registerFetching}>
              <FormattedMessage id="Register" />
            </Button>
          </Col>
        </Row>
        {this.props.registerResponse ? (
          <Row className="mb-3">
            <Col>
              <Alert color="success">
                {<FormattedMessage id="register.Success.ConfirmEmail" />}
              </Alert>
            </Col>
          </Row>
        ) : null}
        {this.props.registerError ? (
          <Row className="mb-3">
            <Col>
              <Alert color="danger">{this.props.registerError}</Alert>
            </Col>
          </Row>
        ) : null}
        {
          <div>
            <Row className="mb-3">
              <Col>
                <div className="dashed">
                  <span>
                    <FormattedMessage id="Or" />
                  </span>
                </div>
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <GoogleLogin
                  clientId={AppConfig.google.clientId}
                  onSuccess={response => this.responseGoogle(response)}
                  onFailure={response => this.responseGoogle(response)}
                  render={renderProps => (
                    <Button
                      className="google-btn"
                      onClick={renderProps.onClick}
                      block
                    >
                      <FontAwesomeIcon icon={["fab", "google-plus-g"]} />
                      &nbsp;
                      <FormattedMessage id="SigninWithGoogle" />
                    </Button>
                  )}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col>
                <FacebookLogin
                  appId={AppConfig.facebook.appId}
                  autoLoad={false}
                  fields="name,email,picture"
                  callback={response => this.responseFacebook(response)}
                  render={renderProps => (
                    <Button
                      onClick={renderProps.onClick}
                      className="facebook-btn"
                      block
                    >
                      <FontAwesomeIcon icon={["fab", "facebook-f"]} />
                      &nbsp;
                      <FormattedMessage id="SigninWithFacebook" />
                    </Button>
                  )}
                />
              </Col>
            </Row>
          </div>
        }
      </ValidationForm>
    )
  }
}

const mapStateToProps = state => {
  return {
    registerFetching: state.SagaAuth.customerRegisterFetching,
    registerResponse: state.SagaAuth.customerRegisterResponse,
    registerError: state.SagaAuth.customerRegisterError
  }
}

const mapDispatchToProps = dispatch => {
  return {
    requestRegister: (data: IRegister) =>
      dispatch(SagaAuthRedux.requestRegister(data)),
    requestExternalLogin: (data: IExternalSignin) =>
      dispatch(SagaAuthRedux.requestExternalLogin(data)),

    requestCustomerRegister: (customerReq: ICustomerReq) =>
      dispatch(SagaAuthRedux.requestCustomerRegister(customerReq))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)



// WEBPACK FOOTER //
// ./src/components/accountModal/register.tsx